import WebHttpClient from '../../httpClient/WebHttpClient';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { IAlertListInfo } from '../../ts/models/IAlertInfo';
import { GetAlertRequest, IGetAlertResult } from '../../ts/ServerApi/requests/GetAlertRequest';
import { GetUserAlertCountRequest, IGetUserAlertCountResult } from '../../ts/ServerApi/requests/GetUserAlertCountRequest';
import { GetUserAlertListRequest, IGetUserAlertListResult } from '../../ts/ServerApi/requests/GetUserAlertListRequest';

export namespace Alerts {

  export function getCount(): Promise<number> {
    return WebHttpClient.sendRequest(new GetUserAlertCountRequest())
      .then((result: IGetUserAlertCountResult) => {
        return result.totalCount;
      });
  }

  export function getList(): Promise<IAlertListInfo> {
    return WebHttpClient.sendRequest(new GetUserAlertListRequest())
      .then((result: IGetUserAlertListResult) => {
        return ServerApiMapper.alertList(result);
      });
  }

  export function getForType(type: string, id: string): Promise<IAlertListInfo> {
    return WebHttpClient.sendRequest(new GetAlertRequest({
      targetType: type,
      targetId: id
    })).then((result: IGetAlertResult) => {
      return ServerApiMapper.alertList(result);
    });
  }

}
